export default {"src":"/_next/static/media/makemytrip.082530f0.svg","height":153,"width":153,"blurWidth":0,"blurHeight":0};